import { useState } from "react";
import { postApi } from "../../apis/api";
import { DownloadIcon } from "../../assets";
import { useMessage } from "../../context/MessageContext";
import { GENERAL_ERROR_MESSAGE } from "../../utils/message";
import { Loader } from "../loaders/loaders";

type ExportOptions = {
  url: string;
  payload?: any;
  fallbackFileName?: string;
};

export const exportExcelFromPostApi = async ({
  url,
  payload = {},
  fallbackFileName = "export.xlsx",
}: ExportOptions) => {
  try {
    const apiResponse = await postApi<any>(
      url,
      payload
    );

    if (!apiResponse?.success || !apiResponse?.data) {
        return {
        success: false,
        errorMessage: apiResponse?.error?.message,
      };

    }
    // window.open(apiResponse.data.url, "_blank");
    const { url: fileUrl, fileName } = apiResponse.data;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute(
      "download",
      fileName?.split("/").pop() || fallbackFileName
    );

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

   return {
    success: true,
    message: apiResponse?.message,
   };
  } catch (error) {
    console.error("Export failed", error);
    return {
      success: false,
      errorMessage: "Error in exporting file!",
    };
  }
};

type ExportButtonProps = {
  url: string;
  payload?: any;
  fileName?: string;
  label?: string;
  className?: string;
};

const ExportExcelButton: React.FC<ExportButtonProps> = ({
  url,
  payload = {},
  fileName = "export.xlsx",
  label = "Export All",
  className = "btn btn__white w_fitContent",
}) => {
  const [loading, setLoading] = useState(false);
  const { setMessage } = useMessage();
 
  const handleClick = async () => {
    if (loading) return;

    try {
      setLoading(true);
      const result = await exportExcelFromPostApi({
        url,
        payload,
        fallbackFileName: fileName,
      });

      if (!result?.success) {
        setMessage(
          result?.errorMessage || GENERAL_ERROR_MESSAGE,
          "error"
        );
        return;
      }
      setMessage(
      result?.message || "File exported successfully!",
      "success"
    );
    } finally {
      setLoading(false);
    }
  };

  if(loading){
    return <Loader/>
  }

  return (
    <button className={className} onClick={handleClick} disabled={loading}>
      <DownloadIcon />
      {loading ? "Exporting..." : label}
    </button>
  );
};

export default ExportExcelButton;